module.exports = __webpack_public_path__ + "static/media/sort-descending.bc7368f6.svg";